//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** Flag indicating if communication is for all selected segments or any segments */
export const SegmentCriteria = {
    /** All */
    All: 0,

    /** Any */
    Any: 1
} as const;

/** Flag indicating if communication is for all selected segments or any segments */
export const SegmentCriteriaDescription: Record<number, string> = {
    0: "All",

    1: "Any"
};

/** Flag indicating if communication is for all selected segments or any segments */
export type SegmentCriteria = typeof SegmentCriteria[keyof typeof SegmentCriteria];
